import { type MainWindow } from "owa-freeze-dry";
import { getSelectedTableView, getFocusedFilterForTable, MailRowDataPropertyGetter } from "owa-mail-list-store";
import { getSelectedNode } from "owa-mail-folder-forest-store";
import { getAttachmentIds } from "./getCLPInfo";

export function createMainWindowItem(): Partial<MainWindow> {
    const mainWindow: Partial<MainWindow> = {};
    
    const tableView = getSelectedTableView();
    const rowKey = tableView && [...tableView.selectedRowKeys?.keys()]?.[0];
    const item = MailRowDataPropertyGetter.getItem(rowKey, tableView);
    
    Object.assign(mainWindow, {
        folderId: getSelectedNode()?.id,
        rowKey,
        focusedViewFilter: getFocusedFilterForTable(tableView),
        globalItemId: MailRowDataPropertyGetter.getLatestGlobalItemId(rowKey, tableView),
        attachmentIds: getAttachmentIds(item),
    });
    
    return mainWindow;
}
